import { unavailableOnWeb } from './unavailableOnWeb.web';
/**
 * Web stub for `expo-intent-launcher`, which is Android-only. Its callers check
 * for Android before calling it.
 */
export const openEmailApp = unavailableOnWeb('IntentLauncher.openEmailApp');
export const openSettings = unavailableOnWeb('IntentLauncher.openSettings');
export const openApp = unavailableOnWeb('IntentLauncher.openApp');
